import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { NotifierService } from 'angular-notifier';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { ErrorDetailsDialogData } from '../../../../core/interfaces/error-details-dialog';
import { ErrorDetailsDialogs, ErrorDetailsDialogsGetter } from './error-details-dialogs.enum';

interface ErrorDetailsModalData {
  mode: ErrorDetailsDialogs,
  details: {}
}

@Component({
  selector: 'app-error-details-dialog',
  templateUrl: './error-details-dialog.component.html',
  styleUrls: ['./error-details-dialog.component.scss']
})
export class ErrorDetailsDialogComponent implements OnInit {
  populatedData: ErrorDetailsDialogData;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ErrorDetailsModalData,
    public dialogRef: MatDialogRef<ErrorDetailsDialogComponent>,
    private translateService: TranslateService,
    private notifier: NotifierService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer) {
    this.matIconRegistry.addSvgIcon(
      'copy',
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/copy.svg")
    );
  }

  ngOnInit(): void {
    this.populatedData = ErrorDetailsDialogsGetter.getDialogData(this.data.mode);
  }

  onCopied(event: any, label: string) {
    if (event.isSuccess) {
      this.notifier.notify('success', this.translateService.instant(label) + ' ' + this.translateService.instant('errors.details.copiedToClipboard'));
    }
  }

  onCopyToClipboard(event: MouseEvent) {
    event.preventDefault();
  }

  onClose(event) {
    event.stopPropagation();
    this.dialogRef.close();
  }
}
